import React from 'react';

const SurveyIntro = ({ onStart, customTitle, customMessage }) => {
  const title = customTitle || 'Career Interest Survey';
  const message = customMessage || 'Discover your career interests and find the right path for your future';

  return (
    <div className="max-w-2xl mx-auto text-center">
      <div className="bg-white rounded-lg shadow-lg p-8">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800 mb-4">
            {title}
          </h1>
          <p className="text-lg text-gray-600">
            {message}
          </p>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-8 text-left">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            About This Survey
          </h2>
          <ul className="space-y-3 text-gray-700">
            <li className="flex items-start">
              <span className="text-blue-600 mr-2">•</span>
              <span>
                Based on the RIASEC career interest model (Realistic, Investigative,
                Artistic, Social, Enterprising, Conventional)
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-blue-600 mr-2">•</span>
              <span>30 questions across 5 steps</span>
            </li>
            <li className="flex items-start">
              <span className="text-blue-600 mr-2">•</span>
              <span>Takes approximately 5-10 minutes to complete</span>
            </li>
            <li className="flex items-start">
              <span className="text-blue-600 mr-2">•</span>
              <span>
                Select all activities that interest you - there are no wrong answers
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-blue-600 mr-2">•</span>
              <span>
                You'll receive personalized career cluster recommendations based on your responses
              </span>
            </li>
          </ul>
        </div>

        <button
          onClick={onStart}
          className="
            px-8 py-3 rounded-lg font-semibold text-lg
            bg-blue-600 text-white hover:bg-blue-700
            transition-all shadow-md hover:shadow-lg
          "
        >
          Start Survey
        </button>
      </div>
    </div>
  );
};

export default SurveyIntro;
